import { useEffect, useMemo, useState } from 'react';
import enterpriseAPI from "../API/enterpriseAPI";
import API from "../API";

export const useFetchLqr = ({ qrId, route }) => {
    const [state, setState] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const enterprise = useMemo(() => {
        if (!route || !route?.includes('/')) return '';
        return route.split('/')[0];
    }, [route]);

    useEffect(() => {
        let isMounted = true;

        const handleFetchLiquidQr = async () => {
            try {
                setLoading(true);
                if (enterprise) {
                    const { data } = await enterpriseAPI.getBrandQr(enterprise);
                    if (isMounted) {
                        setState({ ...data, data: `${window.location.origin}/${route}`, height: 250, width: 250 });
                    };
                } else if (qrId && process.env.REACT_APP_LQR !== 'false') {
                    const { data } = await API.retrieveLiquidQr({ qrId: qrId });
                    if (data?.qr_style && isMounted) {
                        setState({ ...data.qr_style, height: 250, width: 250 });
                    };
                };
            } catch (err) {
                console.error(err);
                if (isMounted) setState({ error: true });
            } finally {
                setLoading(false);
            };
        };

        if (!qrId && !enterprise) {
            setState(null);
            setLoading(false);
            return;
        };

        handleFetchLiquidQr();

        return () => isMounted = false;
    }, [qrId, enterprise, route]);

    return loading === false && state;
};